export default __webpack_public_path__ + "static/aws-deepracer-img-4-6cca9d8dbc7d116b213b4ad1ad4816bc.jpg";